// eslint-disable-next-line import/prefer-default-export
export const getOidcUser = state => state.oidc.user;
